/**
 * コレクション familysale の閲覧パスワードゲート
 * Cookie がある場合は解除、ない場合はフォームを表示
 */
(function () {
  'use strict';

  var gate = document.getElementById('CollectionPasswordGate');
  if (!gate) return;

  var password = gate.getAttribute('data-password') || '';
  var cookieName = gate.getAttribute('data-cookie-name') || 'collection_auth_familysale';
  var form = gate.querySelector('[data-collection-password-form]');
  var errorEl = gate.querySelector('[data-collection-password-error]');
  var input = gate.querySelector('#CollectionPasswordInput');
  var cookieDays = 7;

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=' +
      maxAge +
      '; SameSite=Lax' +
      secure;
  }

  function unlock() {
    document.body.classList.remove('collection-password-locked');
    gate.classList.remove('is-active');
    gate.setAttribute('aria-hidden', 'true');
    gate.hidden = true;
  }

  function lock() {
    document.body.classList.add('collection-password-locked');
    gate.hidden = false;
    gate.classList.add('is-active');
    gate.setAttribute('aria-hidden', 'false');
    if (input) input.focus();
  }

  if (getCookie(cookieName) === '1') {
    unlock();
  } else {
    lock();
  }

  if (!form) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var value = input ? input.value.trim() : '';

    if (value === password) {
      if (errorEl) errorEl.hidden = true;
      setCookie(cookieName, '1', cookieDays);
      unlock();
      return;
    }

    if (errorEl) errorEl.hidden = false;
    if (input) {
      input.value = '';
      input.focus();
    }
  });
})();
